import {t} from 'common/utils/translation-util';

export const HIDE = {
  label: t('Hide'),
  value: false,
};

export const SHOW = {
  label: t('Show'),
  value: true,
};
